import React, { useState, useEffect } from 'react';
import { NewTraining, newTrainings } from '../../../../const/newTraining';
import { use } from 'i18next';
import { inscribe } from './Inscribe';
import ContactBar from './ContactBar';


const Calendar = () => {

    const [ trainings, setTrainings ] = useState<NewTraining[]>([])

    useEffect(() => {
        setTrainings(newTrainings);
    }, [])

    const handleInscribe = (title: string) => {
        inscribe(title);
    }

    return (
        <>  
        <div id="tab-calendrier" className="section">
            <div className="section-title">Calendrier des sessions — 2025</div>
            <div className="section-sub">Sessions disponibles en présentiel et à distance — Cameroun, Gabon, RCA, Congo, Togo, Tchad, Guinée équatoriale</div>

            {/* <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginBottom: "1rem" }}>
                <button onClick="filterCal('all',this)" className="cal-filter" style={{ padding: "4px 12px", border: "0.5px solid rgba(0,0,0,0.2)", borderRadius: "20px", fontSize: "12px", background: "#1D9E75", color: "#E1F5EE", cursor: "pointer", fontWeight: "500" }}>Toutes les sessions</button>
                <button onClick="filterCal('presentiel',this)" className="cal-filter" style={{ padding: "4px 12px", border: "0.5px solid rgba(0,0,0,0.2)", borderRadius: "20px", fontSize: "12px", background: "none", color: "#666", cursor: "pointer" }}>Présentiel uniquement</button>
                <button onClick="filterCal('distance',this)" className="cal-filter" style={{ padding: "4px 12px", border: "0.5px solid rgba(0,0,0,0.2)", borderRadius: "20px", fontSize: "12px", background: "none", color: "#666", cursor: "pointer" }}>À distance uniquement</button>
            </div> */}

            {
                trainings.length === 0 && (
                    <div style={{ textAlign: "center", padding: "50px 0", color: "#666" }}>
                        <i className="fa fa-spinner fa-spin" style={{ fontSize: "24px" }}></i>
                        <div style={{ marginTop: "10px" }}>Chargement des formations...</div>
                    </div>
                )
            }

            <div style={{ background: "#fff", border: "0.5px solid rgba(0,0,0,0.12)", borderRadius: "12px", overflow: "auto" }}>
                <table className="calendar-table">
                <thead><tr>
                    <th>Formation</th><th>Dates</th><th>Durée</th><th>Ville</th><th>Mode</th><th>Places</th><th></th>
                </tr></thead>
                {trainings.length > 0 && (
                trainings.map((training) => (
                <tbody id="cal-body">
                    <tr data-mode="presentiel">
                        <td style={{ fontWeight: "500" }}>DevOps & CI/CD</td>
                        <td>10–14 juin 2025</td>
                        <td>5 jours</td>
                        <td><span className="city-pill city-douala">Douala</span></td>
                        <td><span className="mode-pill mode-presentiel">Présentiel</span></td>
                        <td><span className="avail avail-open"></span>Ouvert</td>
                        <td><button
                         className="enroll-btn" 
                         style={{ fontSize: "11px", padding: "5px 10px" }} 
                         onClick={() => handleInscribe(training.title)}
                         >S'inscrire</button>
                        </td>
                    </tr>
                </tbody>
                )))}
                </table>
            </div>

            <div style={{ marginTop: "12px", display: "flex", gap: "16px", flexWrap: "wrap", fontSize: "12px", color: "#aaa" }}>
                <span><span className="mode-pill mode-presentiel" style={{ marginLeft: "0" }}>Présentiel</span> Formation dans la ville indiquée</span>
                <span><span className="mode-pill mode-distance" style={{ marginLeft: "0" }}>À distance</span> Formation en visioconférence</span>
            </div>
            <div style={{ marginTop: "8px", fontSize: "12px", color: "#aaa" }}>Sessions intra-entreprise disponibles dans toutes les villes — <a href="mailto:contact@ova-consulting.fr?subject=Demande session intra-entreprise" style={{ color: "#0F6E56" }}>nous contacter</a> pour planifier.</div>
        </div>
        {/* <ContactBar /> */}
        </>
    )
}

export default Calendar;